import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Application_of_Geo_Informatics_for_Planning_Poster from '../../../Assets/Images/ProjectsImg/TrainingCertificateCourses/Application_of_Geo_Informatics_for_Planning.png'
import Application_of_Geo_Informatics_for_Planning1 from '../../../Assets/Images/Training/Certificate cources/Application of Geo-Informatics for Planning/Application_of_Geo_Informatics_for_Planning1.jpg';
import Application_of_Geo_Informatics_for_Planning2 from '../../../Assets/Images/Training/Certificate cources/Application of Geo-Informatics for Planning/Application_of_Geo_Informatics_for_Planning2.jpg';
import Application_of_Geo_Informatics_for_Planning3 from '../../../Assets/Images/Training/Certificate cources/Application of Geo-Informatics for Planning/Application_of_Geo_Informatics_for_Planning3.jpg';

import Concept_Note from '../../../Assets/Images/Training/Certificate cources/Application of Geo-Informatics for Planning/Concept_Note.pdf';
import Schedule_of_FPDP_6_10_January_2025 from '../../../Assets/Images/Training/Certificate cources/Application of Geo-Informatics for Planning/Schedule_of_FPDP_6_10_January_2025.pdf';

const Application_of_Geo_Informatics_for_Planning = () => {

    return (
        <div className="mt-5">
            <h4>Application of Geo-Informatics for Planning</h4>

            <div className="card mt-5">
                <img
                    src={Application_of_Geo_Informatics_for_Planning_Poster}
                    className="card-img-top"
                    alt="Poster"
                />
            </div>

            <div className="mt-5">
                <p>The Centre of Excellence (CoE) – Urban Planning and Design, Ministry of Housing and Urban Affairs, established at the School of Planning and Architecture, New Delhi (SPA), organized a Faculty and Professional Development Programme (FPDP) on ‘Application of Geo-Informatics for Planning’ from 6 to 10 January 2025.</p>
                <p>The Department of Regional Planning at SPA New Delhi was responsible for the smooth execution of the programme and ensured that the event offered a holistic learning experience for participants to integrate geoinformatics into their professional practices.</p>
                <p>The FPDP aimed to equip participants with the latest advancements in remote sensing and Geographic Information Systems (GIS) applications. It focused on developing technical skills and competence in data and information acquisition, extraction, management, and analysis, as well as spatial and statistical modelling, mapping, and visualisation.</p>
                <p>The event provided a platform for academicians, researchers, professionals, and policymakers to learn and share cutting-edge research, innovations, and applications in Geoinformatics. It empowered participants with the skills and knowledge needed to address contemporary planning challenges using advanced geospatial tools.</p>
            </div>


            <div className="row mb-4 mt-5">
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Application_of_Geo_Informatics_for_Planning1} className="card-img-top" alt="Event" />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Application_of_Geo_Informatics_for_Planning2} className="card-img-top" alt="Event" />
                    </div>
                </div>
                <div className="col-md-4 mb-3">
                    <div className="card">
                        <img src={Application_of_Geo_Informatics_for_Planning3} className="card-img-top" alt="Event" />
                    </div>
                </div>
            </div>

            <div className="mb-4">
                <p><strong>Concept Note: </strong>
                    <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                            window.open(Concept_Note, '_blank');
                        }}
                    >
                        Open PDF
                    </button>
                </p>
                <p><strong>Programme Schedule: </strong>
                    <button
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => {
                            window.open(Schedule_of_FPDP_6_10_January_2025, '_blank');
                        }}
                    >
                        Open PDF
                    </button>
                </p>
            </div>

            <div>
                <p><strong>Timeline:</strong> 6 January 2025 - 10 January 2025</p>
                <p><strong>Status:</strong> Completed</p>
            </div>
        </div>
    );
};

export default Application_of_Geo_Informatics_for_Planning;

